import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import User from "./User";
import Offer from "./Offer";
import Image from "../library/Image";
import Country from "./Country";
import StoreCustomData from "./StoreCustomData";
import Model from "./Model";
export class Store extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "id", {
      fieldName: 'domain_id',
      fieldTitle: 'Domain id',
      content: null
    });
    _defineProperty(this, "Id", {
      fieldName: 'domain_id',
      fieldTitle: 'Domain id',
      content: null
    });
    _defineProperty(this, "DomainId", {
      fieldName: 'domain_id',
      fieldTitle: 'Domain id',
      content: null
    });
    _defineProperty(this, "DomainType", {
      fieldName: 'domain_type',
      fieldTitle: 'Domain type',
      content: null
    });
    _defineProperty(this, "DomainOfferID", {
      fieldName: 'offer_id',
      fieldTitle: 'Domain offer id',
      content: null
    });
    _defineProperty(this, "DomainOffer", {
      fieldName: 'domain_offer',
      fieldTitle: 'Domain offer',
      model: Offer,
      content: null
    });
    _defineProperty(this, "DomainCountryID", {
      fieldName: 'domain_type_country_id',
      fieldTitle: 'Domain country id',
      content: null
    });
    _defineProperty(this, "DomainCountry", {
      fieldName: 'domain_type_country',
      fieldTitle: 'Domain country',
      model: Country,
      content: null
    });
    _defineProperty(this, "DomainName", {
      fieldName: 'domain_name',
      fieldTitle: 'Domain name',
      content: null
    });
    _defineProperty(this, "name", {
      fieldName: 'domain_name',
      fieldTitle: 'Domain name',
      content: null
    });
    _defineProperty(this, "DomainUser", {
      fieldName: 'domain_user',
      fieldTitle: 'Domain user',
      model: User,
      content: null
    });
    _defineProperty(this, "DomainBelongType", {
      fieldName: 'domain_belong_type',
      fieldTitle: 'Domain type',
      content: null
    });
    _defineProperty(this, "DomainIsDefault", {
      fieldName: 'domain_is_default',
      fieldTitle: 'Domain is default',
      content: null
    });
    _defineProperty(this, "DomainTitle", {
      fieldName: 'domain_title',
      fieldTitle: 'Domain Title',
      content: null
    });
    _defineProperty(this, "DomainEmail", {
      fieldName: 'domain_contact_email',
      fieldTitle: 'Domain Contact Email',
      content: null
    });
    _defineProperty(this, "DomainLogo", {
      fieldName: 'domain_logo',
      fieldTitle: 'Domain Logo',
      content: null
    });
    _defineProperty(this, "DomainFavicon", {
      fieldName: 'domain_favicon',
      fieldTitle: 'Domain Favicon',
      content: null
    });
    _defineProperty(this, "DomainDNS", {
      fieldName: 'domain_dns',
      fieldTitle: 'Domain Dns',
      content: null
    });
    _defineProperty(this, "DomainSSL", {
      fieldName: 'domain_ssl',
      fieldTitle: 'Domain Ssl',
      content: null
    });
    _defineProperty(this, "DomainPrimaryColor", {
      fieldName: 'domain_primary_color',
      fieldTitle: 'Domain primary color',
      content: null
    });
    _defineProperty(this, "DomainSecondaryColor", {
      fieldName: 'domain_secondary_color',
      fieldTitle: 'Domain secondary color',
      content: null
    });
    _defineProperty(this, "DomainLogoGallery", {
      fieldName: 'domain_logo_gallery',
      fieldTitle: 'Domain Logo',
      model: Image,
      content: null
    });
    _defineProperty(this, "logo", {
      fieldName: 'logo',
      fieldTitle: 'Domain Logo',
      model: Image,
      content: null
    });
    _defineProperty(this, "DomainFaviconGallery", {
      fieldName: 'domain_favicon_gallery',
      fieldTitle: 'Domain Favicon',
      model: Image,
      content: null
    });
    _defineProperty(this, "DomainVerificationString", {
      fieldName: 'domain_verification_string',
      content: null
    });
    _defineProperty(this, "phoneNumber", {
      fieldName: 'phone_number',
      content: null
    });
    _defineProperty(this, "companyLocation", {
      fieldName: 'company_location',
      content: null
    });
    _defineProperty(this, "customData", {
      fieldName: 'custom_data',
      model: StoreCustomData,
      content: null
    });
  }
  getLogo() {
    var _ref, _this$logo$content;
    return (_ref = (_this$logo$content = this.logo.content) !== null && _this$logo$content !== void 0 ? _this$logo$content : this.DomainLogoGallery.content) !== null && _ref !== void 0 ? _ref : this.DomainLogo.content;
  }
  getCustomData() {
    return this.customData.content;
  }
  isPaymentWalletsEnabled() {
    let customData = this.getCustomData();
    return customData instanceof StoreCustomData ? customData.isPaymentWalletsEnabled() : null;
  }
  getId() {
    return this.Id.content;
  }
  isDefault() {
    return this.DomainIsDefault.content;
  }
  storeName() {
    return this.DomainTitle.content;
  }
  getPhoneNumber() {
    return this.phoneNumber.content;
  }
  getCompanyLocation() {
    return this.companyLocation.content;
  }
  getEmail() {
    return this.DomainEmail.content;
  }
  getDomainVerificationString() {
    var _this$DomainVerificat;
    return (_this$DomainVerificat = this.DomainVerificationString) === null || _this$DomainVerificat === void 0 ? void 0 : _this$DomainVerificat.content;
  }
  getDomainSelectObject(text = null, value = null, returnHoleObject = false) {
    var _this$DomainName, _this$DomainId;
    let option = {
      [text !== null && text !== void 0 ? text : 'text']: (_this$DomainName = this.DomainName) === null || _this$DomainName === void 0 ? void 0 : _this$DomainName.content,
      [value !== null && value !== void 0 ? value : 'value']: (_this$DomainId = this.DomainId) === null || _this$DomainId === void 0 ? void 0 : _this$DomainId.content
    };
    if (returnHoleObject) option.domain = this;
    return option;
  }
  isSSL() {
    var _this$DomainSSL$conte, _this$DomainSSL;
    return (_this$DomainSSL$conte = (_this$DomainSSL = this.DomainSSL) === null || _this$DomainSSL === void 0 ? void 0 : _this$DomainSSL.content) !== null && _this$DomainSSL$conte !== void 0 ? _this$DomainSSL$conte : false;
  }
  isDNS() {
    var _this$DomainDNS$conte, _this$DomainDNS;
    return (_this$DomainDNS$conte = (_this$DomainDNS = this.DomainDNS) === null || _this$DomainDNS === void 0 ? void 0 : _this$DomainDNS.content) !== null && _this$DomainDNS$conte !== void 0 ? _this$DomainDNS$conte : false;
  }
  hasDnsActive() {
    var _this$DomainDNS$conte2, _this$DomainDNS2;
    return (_this$DomainDNS$conte2 = (_this$DomainDNS2 = this.DomainDNS) === null || _this$DomainDNS2 === void 0 ? void 0 : _this$DomainDNS2.content) !== null && _this$DomainDNS$conte2 !== void 0 ? _this$DomainDNS$conte2 : false;
  }
  hasSslActive() {
    var _this$DomainSSL$conte2, _this$DomainSSL2;
    return (_this$DomainSSL$conte2 = (_this$DomainSSL2 = this.DomainSSL) === null || _this$DomainSSL2 === void 0 ? void 0 : _this$DomainSSL2.content) !== null && _this$DomainSSL$conte2 !== void 0 ? _this$DomainSSL$conte2 : false;
  }
  getDomainName() {
    var _this$DomainName2;
    let domain = (_this$DomainName2 = this.DomainName) === null || _this$DomainName2 === void 0 ? void 0 : _this$DomainName2.content;
    return domain === 'localhost' ? 'localhost:3000' : domain;
  }
  getName() {
    var _this$name;
    let domain = (_this$name = this.name) === null || _this$name === void 0 ? void 0 : _this$name.content;
    return domain === 'localhost' ? 'localhost:3000' : domain;
  }
  getTitle() {
    return this.DomainTitle.content;
  }
  getPrimaryColor() {
    return this.DomainPrimaryColor.content;
  }
  getSecondaryColor() {
    return this.DomainSecondaryColor.content;
  }
  getType() {
    return this.DomainType.content;
  }
  isBrand() {
    return this.getType() === Store.BRAND_TYPE;
  }
}
_defineProperty(Store, "GENERAL_TYPE", 'general');
_defineProperty(Store, "BRAND_TYPE", 'brand');
_defineProperty(Store, "COUNTRY_TYPE", 'country');
_defineProperty(Store, "DEFAULT_PRIMARY_COLOR", '#05254B');
_defineProperty(Store, "DEFAULT_SECONDARY_COLOR", '#70C5FF');
export default Store;